export default __webpack_public_path__ + "static/media/noVoucher.f705cd72.png";